import faPlus from '@fortawesome/fontawesome-pro-light/faPlus';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { MenuContainer } from '@zendeskgarden/react-menus';
import Tooltip from 'rc-tooltip';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { ModalActions } from '../../../../../../actions/modal';
import { elementTypesSelector } from '../../../../../../reducers/elementTypes';
import { userModeSelector, userRolesSelector } from '../../../../../../reducers/users';
import immutableCreatorSelector from '../../../../../../selectors/immutableCreatorSelector';
import CreateNewTasksModal from '../../../../../modals/CreateNewTasks';

const CreateButtonSelector = immutableCreatorSelector(
  [userRolesSelector, userModeSelector, elementTypesSelector],
  (userRoles, userMode, elementTypes) => ({
    userRoles,
    userMode,
    elementTypes,
  }),
);

const CustomMenuContainer = styled.div`
  z-index: 1071;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  marginleft: 0px;
  :focus {
    outline: none;
  }
`;

const CustomMenuItem = styled.div`
  padding: 8px 4px;
  background-color: ${({ focused }) => (focused ? 'grey' : 'initial')};
  cursor: pointer;
  :hover {
    color: #5e97be;
    text-decoration: none;
    background-color: #f8f9fa;
  }
  display: block;
  width: 100%;
  padding: 0.25rem 0.5rem;
  clear: both;
  font-weight: 400;
  text-align: inherit;
  white-space: nowrap;
  color: #5e97be;
  border: 0;
`;

@connect(CreateButtonSelector)
class CreateIcon extends React.Component {
  initialState = {
    selectedKey: 'Unknown',
  };

  state = {
    showCreateTaskModal: false,
    isOpen: false,
  };

  toggleModal = () => {
    console.log('toggle', !this.state.showCreateTaskModal);
    this.setState({ showCreateTaskModal: !this.state.showCreateTaskModal });
  };

  handleClick = (modalName, options) => {
    const { dispatch } = this.props;
    dispatch(
      ModalActions.toggleModal({
        name: modalName,
        options,
      }),
    );
  };

  handleClickNewType = typeId => {
    this.handleClick('CreateElementNewModal', {
      elementTypeId: typeId,
    });
  };

  getProjectMenuItems = getItemProps => {
    const { elementTypes, userMode } = this.props;
    return elementTypes
      .filter(
        elementType =>
          elementType.get('type') !== 'System' &&
          elementType.get('type') !== 'Work Breakdown Structure',
      )
      .reduce((prev, eleType) => {
        const adminOnly = eleType.getIn(
          ['props', '_global', '_adminCreate', '_value'],
          true,
        );
        const elementTypeId = eleType.get('id');
        const elementTypeName = eleType.get('type');
        const onClickHandler =
          elementTypeName === 'Task'
            ? this.toggleModal
            : this.handleClickNewType;

        const dataTestMap = {
          Task: 'taskMenuItem',
          Milestone: 'milestoneMenuItem',
          Company: 'companyMenuItem',
        };

        if (userMode === 'admin' || (userMode === 'user' && !adminOnly)) {
          return prev.concat(
            <CustomMenuItem
              {...getItemProps({
                key: elementTypeId,
                textValue: elementTypeId,
                // focused: focusedKey === item.id,
              })}
              key={elementTypeId}
              // className="dropdown-item quick-add-by-type"
              onClick={onClickHandler.bind(this, elementTypeId)}
              // typeId={elementTypeId}
              // title={elementTypeName}
              data-test={dataTestMap[elementTypeName] || null}
            >
              <div>{elementTypeName}</div>
              {/* {elementTypeName === 'Task' && (
                <CreateNewTasksModal
                  showModal={this.state.showCreateTaskModal}
                  handleCloseModal={this.toggleModal}
                  contentLabel="Create New Task(s)"
                  typeId={elementTypeId}
                />
              )} */}
            </CustomMenuItem>,
          );
        }

        return prev;
      }, []);
  };

  handleStateChange = state => {
    // const { enableTooltip, disableTooltip } = this.props;
    // state.isOpen ? disableTooltip() : enableTooltip();
    this.setState({
      isOpen: state.isOpen,
    });
  };

  render() {
    const {
      // userRoles,
      // enableTooltip,
      // disableTooltip,
      elementTypes,
    } = this.props;

    const taskElementType = elementTypes
      .filter(elementType => elementType.get('type') === 'Task')
      .first();

    return (
      <MenuContainer
        theme="main"
        zIndex={1071}
        placement="end-bottom"
        isOpen={this.state.isOpen}
        onStateChange={this.handleStateChange}
        onChange={selectedKey => {}}
        trigger={({ getTriggerProps, triggerRef, isOpen }) => {
          const triggerProps = getTriggerProps({ ref: triggerRef });
          return (
            <React.Fragment>
              <div
                {...triggerProps}
                data-test="quickDropDown"
                style={{
                  cursor: 'pointer',
                }}
              >
                <Tooltip
                  placement="right"
                  overlay={'Create'}
                  // onVisibleChange={this.handleVisibleChange}
                  // visible={tooltipIsVisible}
                >
                  <FontAwesomeIcon
                    className="fa-style"
                    size="lg"
                    icon={faPlus}
                  />
                </Tooltip>
              </div>
              <CreateNewTasksModal
                showModal={this.state.showCreateTaskModal}
                handleCloseModal={this.toggleModal}
                contentLabel="Create New Task(s)"
                typeId={taskElementType && taskElementType.get('id')}
              />
            </React.Fragment>
          );
        }}
      >
        {({ getMenuProps, menuRef, placement, getItemProps, focusedKey }) => {
          return (
            <CustomMenuContainer
              {...getMenuProps({
                innerRef: menuRef,
                onStateChange: this.handleStateChange,
              })}
            >
              {this.getProjectMenuItems(getItemProps)}
            </CustomMenuContainer>
          );
        }}
      </MenuContainer>
    );
  }
}

export default CreateIcon;



// WEBPACK FOOTER //
// ./src/components/toolbars/IconNavList/industry/construction/CreateIcon/CreateIcon.js